import { NavLink, useLocation } from "react-router-dom";
import { Box, Tabs, Tab, tabsClasses } from "@mui/material";
import WebOnly from "./WebOnly";
import APIResponse from "../types/APIResponse";

export default function ResultsTabs({
  response,
  pathPrefix,
}: {
  response: APIResponse | null;
  pathPrefix: string;
}) {
  const location = useLocation();

  return (
    <WebOnly>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={location.pathname}
          // Addressed through tabsClasses rather than a literal, because
          // MUI 9 renamed this element's class from `flexContainer` to
          // `list`. A hard-coded selector for a class that no longer exists
          // fails silently -- the tabs just drift back to the left -- and the
          // full-page screenshots are too tall for a header-sized change to
          // clear their 1% diff threshold. The constant makes the rename a
          // type error instead.
          sx={{
            [`& .${tabsClasses.list}`]: {
              justifyContent: "right",
            },
          }}
        >
          <Tab
            to={`${pathPrefix}${location.search}`}
            component={NavLink}
            value={pathPrefix}
            sx={{ px: 2, py: 1, fontSize: "small" }}
            label="Results"
          />
          <Tab
            to={`${pathPrefix}/parameters${location.search}`}
            component={NavLink}
            value={`${pathPrefix}/parameters`}
            sx={{ px: 2, py: 1, fontSize: "small" }}
            label="Parameters"
          />
          <Tab
            to={`${pathPrefix}/json${location.search}`}
            component={NavLink}
            value={`${pathPrefix}/json`}
            sx={{ px: 2, py: 1, fontSize: "small" }}
            label="API response"
          />
        </Tabs>
      </Box>
    </WebOnly>
  );
}
